<p-accordionTab [selected]="true" contentStyleClass="info-card" header="Contact Details">
  <cv-information-entity label="Name" class="name" [value]="data.firstName | fullName: data.lastName" />
  <cv-information-entity
    label="Contact Type"
    [value]="data.inferredContactType"
    [tooltip]="data.inferredContactTypeJustification"
  />
  <cv-information-entity
    label="Contact Subtype"
    [value]="data.inferredContactSubtype"
    [tooltip]="data.inferredContactSubtypeJustification"
  />
  <cv-information-entity
    label="Qualified Prospect"
    [value]="data.qualifiedProspect ? 'Yes' : 'No'"
    [tooltip]="data.qualifiedProspectJustification"
  />
  <cv-information-entity label="Caller ID" [value]="data.callerId | phoneNumber" />
  <cv-information-entity label="Provided Phone Number" [value]="data.providePhone | phoneNumber" />
  <cv-information-entity label="Email" [value]="data.email" />
</p-accordionTab>
